import callWebService, { callTypes } from 'services/utils/networks/network';
import Config from 'services/config/config';
import { LOGIN_OTP, LOGOUT,LOGIN_DATA } from './type';

export const generateOtp = (email, resend) => async (dispatch) => {
  const data = {
    email: email,
  };
  const res = await callWebService(
    callTypes.post,
    data,
    resend
      ? `${Config.loginApiUrl.loginOtp}?resend=true`
      : `${Config.loginApiUrl.loginOtp}`
  );
  if (res?.data?.response?.status === true) {
    dispatch({
      type: LOGIN_OTP,
      payload: res?.data?.response?.status,
    });
    dispatch({
      type: LOGIN_DATA,
      payload: res?.data?.response?.data?.roles,
    });
    localStorage.setItem('fusion-state', res?.data?.response?.data?.state);
    return res?.data?.response?.status;
  } else return false;
};

export const userLogOut = () => async (dispatch) => {
  dispatch({
    type: LOGOUT,
    payload: null,
  });
};
